import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { ApolloLink } from 'apollo-link'
import { RetryLink } from 'apollo-link-retry'
import { onError } from 'apollo-link-error'
import introspectionQueryResultData from './possible-types.json'

// import { createHttpLink } from 'apollo-link-http'

const getCookie = (name, cookies = '') => {
  const cookie = cookies
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(`${name}=`))
  try {
    return cookie
      ? decodeURIComponent(cookie.slice(name.length + 1))
      : undefined
  } catch (e) {
    return undefined
  }
}

const cache = new InMemoryCache({
  introspectionQueryResultData,
})

// Il token JWT va solo sulla query di preview e viene letto dal cookie a ogni richiesta (non all'avvio).
// Login, refresh e query pubbliche partono senza header: un token scaduto nell'header fa fallire tutta la richiesta
const authLink = (getCookies) =>
  setContext(({ operationName }, { headers }) => {
    const isSsrMode = typeof window === 'undefined'
    const token =
      operationName === 'QueryPreview'
        ? getCookie('apollo-token', getCookies())
        : undefined
    return {
      headers: {
        ...(!isSsrMode ? headers : []),
        ...(token ? { authorization: token } : {}),
      },
    }
  })

/* const httpLink = createHttpLink({
  uri: process.env.NUXT_ENV_GQL_URL,
}) */

// Error handling link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    console.error(`[Network error]: ${networkError}`)
    // Handle network errors here (e.g., retry with a delay)
  }
})

// Retry link configuration
const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 5,
    // Le mutation (login, refresh) non vanno ripetute: ogni tentativo di login fallito conta per il lockout di WP
    retryIf: (error, operation) =>
      !!error &&
      !operation.query.definitions.some(
        (definition) => definition.operation === 'mutation'
      ),
  },
})

export default ({ req }) => {
  return {
    httpEndpoint: process.env.NUXT_ENV_GQL_URL,
    getAuth: () => process.env.NUXT_ENV_GQL_KEY,
    cache,
    // https://www.apollographql.com/docs/react/networking/authentication/#header
    link: ApolloLink.from([
      authLink(() =>
        process.server ? req?.headers?.cookie || '' : document.cookie
      ),
      errorLink,
      retryLink,
      // httpLink
    ]),
  }
}
